module.exports = __webpack_public_path__ + "static/media/iphone XR banner4.e681b14f.jpg";